export const BrandBaseColors = {
  brand100: '#FBFBF6',
  brand200: '#f6ffb6',
  brand600: '#E9FF41',
  brand700: '#B3B643',
  brand800: '#7F7F5B',
  brand950: '#1E1E1E',
};

export const DuneBaseColors = {
  dune0: '#FFFFFF',
  dune50: '#FBFAF9',
  dune100: '#F6F6F4',
  dune150: '#F1F1EE',
  dune200: '#EAEAE8',
  dune300: '#E4E4E2',
  dune350: '#C4C3BF',
  dune400: '#ACABA5',
  dune450: '#96948D',
  dune500: '#7C7A73',
  dune550: '#66635C',
  dune600: '#5C5A54',
  dune650: '#53514B',
  dune700: '#474641',
  dune750: '#3B3935',
  dune800: '#2F2E2A',
  dune850: '#262521',
  dune900: '#1E1D1A',
  dune950: '#11100E',
};

export const RedBaseColor = {
  red50: '#FEF2F2',
  red100: '#FFE2E2',
  red200: '#FFC9C9',
  red300: '#FFA2A2',
  red400: '#FF6467',
  red500: '#FB2C36',
  red600: '#E7000B',
  red700: '#C10007',
  red800: '#9F0712',
  red900: '#82181A',
  red950: '#460809',
};
export const redBase = RedBaseColor.red600;

export const YellowBaseColor = {
  yellow50: '#FEFCE8',
  yellow100: '#FEF9C2',
  yellow200: '#FFF085',
  yellow300: '#FFDF20',
  yellow400: '#FCC800',
  yellow500: '#EFB100',
  yellow600: '#D08700',
  yellow700: '#A65F00',
  yellow800: '#894B00',
  yellow900: '#733E0A',
  yellow950: '#432004',
};
export const yellowBase = YellowBaseColor.yellow500;

export const OrangeBaseColor = {
  orange50: '#FFF7ED',
  orange100: '#FFEDD4',
  orange200: '#FFD6A8',
  orange300: '#FFB86A',
  orange400: '#FF8904',
  orange500: '#FF6900',
  orange600: '#F54A00',
  orange700: '#CA3500',
  orange800: '#9F2D00',
  orange900: '#7E2A0C',
  orange950: '#441306',
};
export const orangeBase = OrangeBaseColor.orange500;

export const GreenBaseColor = {
  green50: '#F0FDF4',
  green100: '#DCFCE7',
  green200: '#B9F8CF',
  green300: '#7BF1A8',
  green400: '#05DF72',
  green500: '#00C951',
  green600: '#00A63E',
  green700: '#008236',
  green800: '#016630',
  green900: '#0D542B',
  green950: '#052E16',
};
export const greenBase = GreenBaseColor.green500;

export const BlueBaseColor = {
  blue50: '#EFF6FF',
  blue100: '#DBEAFE',
  blue200: '#BEDBFF',
  blue300: '#8EC5FF',
  blue400: '#51A2FF',
  blue500: '#2B7FFF',
  blue600: '#155DFC',
  blue700: '#1447E6',
  blue800: '#193CB8',
  blue900: '#1C398E',
  blue950: '#162456',
};
export const blueBase = BlueBaseColor.blue500;
